import { translate } from 'localizations';
import { useAppSelector } from 'hooks/redux';
import { RootState } from 'store/store';

export const useReportTranslations = (rowGroupHeaderTitle: string) => {
	const { language } = useAppSelector((state: RootState) => state.lang);

	const getReportRowTitle = (rowTitle: string): string => {
		if (rowTitle === 'time') return translate('reportTime', language);
		if (rowTitle === 'operator_phone') return translate('reportOperatorPhone', language);
		if (rowTitle === 'client_phone') return translate('reportClientPhone', language);
		if (rowTitle === 'tag_name_value') return translate('reportTagValue', language);
		if (rowTitle === 'call') return translate('call', language);
		return rowTitle;
	};

	const selectTitlesOptions = {
		calls: translate('reportTypeCalls', language),
		time: translate('reportGroupByRowTime', language),
		search_items: translate('reportGroupByRowSearchItems', language),
		tag: translate('reportGroupByRowTag', language),
		call: translate('reportCall', language),
		tag_name_list: translate('reportGroupByRowTagNameList', language),
		tag_value_list: translate('reportGroupByRowTagValueList', language),
		tag_name_value: translate('reportGroupByRowTagNameValue', language),
		operator_phone: translate('reportGroupByRowOperatorPhone', language),
		client_phone: translate('reportGroupByRowClientPhone', language),
		calls_count: translate('reportGroupByRowCallsCount', language),
		checklist_avg: translate('reportGroupByChecklist', language),
		stt_engine: translate('reportGroupByRowSttEngine', language),
		hour: translate('reportGroupByTimeHour', language),
		day: translate('reportGroupByTimeDay', language),
		week: translate('reportGroupByTimeWeek', language),
		month: translate('reportGroupByTimeMonth', language),
	};

	const chartTypeOptions = [
		{ label: translate('barChart', language), value: 'barChart' },
		{ label: translate('lineChart', language), value: 'lineChart' },
	];

	const translatedText = {
		name: getReportRowTitle(rowGroupHeaderTitle),
		headerName: getReportRowTitle(rowGroupHeaderTitle),
		callsCount: translate('reportCallsCount', language),

		calls_count: translate('reportCalls', language),
		calls_seconds: translate('reportsTime', language),
		percent_from_total_count: `%`,
		percent_from_all_calls_col: translate('reportPercentageFromAllCallsCol', language),
		percent_from_all_calls_row: translate('reportPercentageFromAllCallsRow', language),

		checklist_avg: translate('reportAverage', language),
		checklist_avg_percent: translate('reportCheckListPercent', language),
		client_talk_time: translate('reportClientTalk', language),
		client_talk_time_percentage: translate('reportClientPercent', language),
		operator_talk_time: translate('reportOperatorTalk', language),
		operator_talk_time_percentage: translate('reportOperatorPercent', language),
		first_call_dt: translate('reportCallDtFirst', language),
		last_call_dt: translate('reportCallDtLast', language),
		silence_duration: translate('reportSilence', language),
		silence_duration_percentage: translate('reportDurationPercent', language),
		tags_count: translate('reportTagsCount', language),
		client_phones: translate('reportClientPhones', language),
		operator_phones: translate('reportOperatorPhones', language),
		points: translate('reportSumPoints', language),
		max_points: translate('reportMaxSumPoints', language),
		from_services: translate('reportFromServices', language),

		row_sum: translate('reportSumCalls', language),
		row_all: translate('reportAllCalls', language),
		row_missed: translate('reportMissedCol', language),

		sumCalls: translate('reportSumCalls', language),
		all: translate('reportAll', language),
		allCalls: translate('reportAllCalls', language),
		missedCol: translate('reportMissedCol', language),
	};

	return {
		getReportRowTitle,
		selectTitlesOptions,
		chartTypeOptions,
		translatedText,
	};
};
